module.exports = __webpack_public_path__ + "e2168e0b6276ef5fb28874ba91722304.svg";